import { Component } from '@angular/core';

@Component({
    selector: 'rwidget-cart-empty',
    templateUrl: './cart-empty.component.html',
})
export class CartEmptyComponent {

}
